import { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./NewsletterPage.css";
import ContactFormWithBackground from "../../components/ContactFormWithBackgroundGray/ContactFormWithBackground";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";

export default function NewsletterPage() {
    const [status, setStatus] = useState({ type: "idle", msg: "" });
    const formRef = useRef(null);

    const siteName = process.env.REACT_APP_SITE_NAME || "unknown-site";

    async function onSubmit(e) {
        e.preventDefault();
        const form = formRef.current;
        const email = form.subscriber_email.value.trim();
        const phone = form.phone_number.value.trim();

        // Honeypot
        if (form.company.value) return;

        // Basic email validation
        if (!/^\S+@\S+\.\S+$/.test(email)) {
            setStatus({ type: "error", msg: "Please enter banking-license valid email." });
            return;
        }

        setStatus({ type: "loading", msg: "Joining the list…" });

        try {
            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                {
                    subscriber_email: email,
                    phone_number: phone,
                    site_name: siteName,
                    page_url: window.location.href,
                },
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            );

            form.reset();
            setStatus({
                type: "success",
                msg: "Thanks for subscribing! Email sent.",
            });
        } catch (err) {
            console.error(err);
            setStatus({
                type: "error",
                msg: "Couldn’t subscribe right now. Please try again.",
            });
        }
    }

  

    return (
        <>
        
    <ContactFormWithBackground />
    {/* 
    <main className="nlp-shell container">
        <section className="nlp-card">
            <div className="nlp-media" aria-hidden="true">
                <img
                    src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1200&auto=format&fit=crop"
                    alt=""
                    loading="eager"
                />
            </div>

            <div className="nlp-formwrap">
                <h1>Join our newsletter</h1>
                <p className="nlp-subtext">
                    join our newsletter and Stay informed about the latest updates and discounts!
                </p>

                <form ref={formRef} onSubmit={onSubmit} noValidate className="nlp-form">
                    <div className="nlp-field">
                        <label htmlFor="subscriber_email">Email</label>
                        <input
                            id="subscriber_email"
                            name="subscriber_email"
                            type="email"
                            placeholder="you@example.com"
                            required
                            aria-invalid={status.type === "error" ? "true" : "false"}
                        />
                    </div>

                    <div className="nlp-field">
                        <label htmlFor="phone_number">Phone (optional)</label>
                        <input
                            id="phone_number"
                            name="phone_number"
                            type="tel"
                            placeholder="+1 555 123 4567"
                        />
                    </div>

                    <input
                        type="text"
                        name="company"
                        tabIndex={-1}
                        autoComplete="off"
                        className="nlp-hp"
                        aria-hidden="true"
                    />

                    <button type="submit" disabled={status.type === "loading"} className="nlp-button">
                        {status.type === "loading" ? "Submitting…" : "Subscribe"}
                    </button>

                    <div role="status" aria-live="polite" className="nlp-status">
                        {status.msg}
                    </div>
                </form>
            </div>
        </section>
    </main>
    */}
</>
    );
}
